// extracted by mini-css-extract-plugin
export default {"suggestion":"SuggestedRow-suggestion_oeQag","pricesContainer":"SuggestedRow-pricesContainer_uVHT4"};